import Icon from '@ant-design/icons'
import { logos } from '@headbox-ui/themes'
import { Layout } from 'antd'
import React, { useEffect, useState, FC } from 'react'
import { useMediaQuery } from 'react-responsive'
import * as s from './styles'
import { ActorSessionMenu, NavBar, SideNav, Spacer } from '..'
import { useRootUrl, useSubNav, useTopNav } from '../../BusinessLogic'
import { BREAKPOINTS } from '../../Constants'
import { generatePendoId } from '../../Utilities'

const { Header: AntdHeader } = Layout
const { HeadBox } = logos

const FadeIn: FC = ({ children }): JSX.Element => {
  const [style, setStyle] = useState({
    transition: 'opacity 0.3s ease-in-out',
    opacity: 0
  })

  useEffect(() => {
    const timeout = setTimeout(() => {
      setStyle((prevStyle) => ({
        ...prevStyle,
        ...{ opacity: 1 }
      }))
    }, 0)
    return () => clearTimeout(timeout)
  }, [])

  return (
    <div style={style}>{children}</div>
  )
}

const Header: FC = (): JSX.Element => {
  const isMediumScreen = useMediaQuery({ maxWidth: BREAKPOINTS.M })
  const rootUrl = useRootUrl()
  const topNav = useTopNav()
  const subNav = useSubNav()

  return (
    <FadeIn>
      <Layout style={s.layout}>
        <AntdHeader className='iAmNav' style={{ ...s.head, ...s.wrapper }}>
          <a href={rootUrl} data-pid={generatePendoId('header', 'logo')} style={s.anchor}>
            <Icon style={s.logo} component={() => <HeadBox />} />
          </a>

          {isMediumScreen ? (
            <SideNav />
          ) : (
            <>
              {topNav !== null && (
                <NavBar links={topNav} navType='topNav' />
              )}
              <ActorSessionMenu />
            </>
          )}

        </AntdHeader>
      </Layout>
      {!isMediumScreen && subNav !== null && (
        <NavBar links={subNav} navType='subNav' />
      )}
      <Spacer height={subNav !== null ? 104 : 64} />
    </FadeIn>
  )
}

export default Header
